import get from 'lodash.get';
import getIsB2C from './is-b2c';

const getHelpCenterUrl = (rootState) => {
  if (getIsB2C(rootState)) {
    return get(rootState, 'config.common.ws-helpcenter.url');
  }

  return get(rootState, 'config.common.ws-helpcenter.wl_url');
};

export default getHelpCenterUrl;
